import { render, staticRenderFns } from "./AddUserProfile.vue?vue&type=template&id=ec1bb9ca&"
import script from "./AddUserProfile.vue?vue&type=script&lang=js&"
export * from "./AddUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddUserProfile.vue"
export default component.exports